var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('h5',[_vm._v("Randomly assigned toplist (from all matching that are generated on Toplists page)")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }